<template>
  <div class="member-already-exists">
    <riseup-header />
    <div class="page">
      <div class="content">
        <div class="emoji ri-giant-display">
          🤷️
        </div>
        <div class="ri-medium-bold-headline padding-top-l">
          מספר הטלפון לא קיים אצלינו במערכת
        </div>
      </div>
      <div class="footer margin-bottom-xl">
        <riseup-button
          class="next-button margin-bottom-l"
          size="small"
          :title="'להרשמה'"
          :action="toSignup"
        />
        <support-footer />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import RiseupButton from '@riseupil/base-ui/src/components/RiseupButton/RiseupButton.vue';
import SupportFooter from '@riseupil/base-ui/src/components/SupportFooter.vue';
import RiseupHeader from '@riseupil/base-ui/src/components/RiseupHeader.vue';
import Segment from '../../Segment';

interface Props {
  action(): void;
}
const props = defineProps<Props>();
Segment.trackUserGot('Login_MemberNotFound_Shown');

function toSignup() {
  Segment.trackUserInteraction('Login_MemberNotFound_ToSignupClicked');
  props.action();
}

</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/mixins';
@import "base-ui-vue3/src/scss/riseup-colors";

.member-already-exists {
  @include white-page-frame;
  height: 100%;

  .page {
    @include white-page-frame;
    @include responsive-padding;
    height: 100%;
    justify-content: space-between;
    text-align: center;
    .content {
      .emoji {
        margin-top: 110px;
      }
    }

    .footer {
      width: 100%;
      .next-button {
        height: 58px;
        width: 100%;
      }
    }
  }
}

</style>
